import { all } from "redux-saga/effects";

import { saga as validarDocumento } from "./actions/validarDocumento";

export default all([validarDocumento]);
